import React, { useState, useEffect } from "react";

const AuthContext = React.createContext({
  isLoggedIn: false,
  userName: '',
  loginError: null,
  onLogout: () => { },
  onLogin: (email, password) => { },
  onGoogleLogin: (token) => { },
});

const decodeJwtName = (token) => {
  try {
    const payload = token.split('.')[1];
    if (!payload) return '';
    // JWT uses Base64Url encoding. We need to convert it to standard Base64 for atob()
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const decoded = JSON.parse(atob(base64));
    console.log("Decoded JWT Token:", decoded); // HILFREICH ZUM DEBUGGEN
    // Fallback auf 'sub', falls 'name' oder 'email' im Backend-Token fehlen
    return decoded.name || decoded.email || decoded.sub || 'Benutzer';
  } catch (e) {
    console.error("Fehler beim Entschlüsseln des Tokens:", e);
    return 'Benutzer'; // Fallback
  }
};

const isTokenExpired = (token) => {
  try {
    const payload = token.split('.')[1];
    if (!payload) return false;
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const decoded = JSON.parse(atob(base64));
    
    if (decoded.exp) {
      // decoded.exp is in seconds, Date.now() is in milliseconds
      return decoded.exp * 1000 < Date.now();
    }
    return false;
  } catch (e) {
    return true; // Im Zweifelsfall (Fehler beim Lesen) ausloggen
  }
};

// named export
export const AuthContextProvider = (props) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userName, setUserName] = useState('');
  const [loginError, setLoginError] = useState(null);

  const logoutHandler = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("isLoggedIn"); // Fallback Cleanup
    setIsLoggedIn(false);
    setUserName('');
    setLoginError(null);
  };

  //### is executed after every component re-evaluation
  // läuft beim start 1 mal, wenn keine dependencies
  useEffect(() => {
    const storedToken = localStorage.getItem("token");

    if (storedToken) {
      if (isTokenExpired(storedToken)) {
        logoutHandler();
      } else {
        setIsLoggedIn(true);
        setUserName(decodeJwtName(storedToken));
      }
    }
  }, []);
  //####

  const loginHandler = async (email, password) => {
    try {
      const response = await fetch("/auth/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ email: email, password: password })
      });

      if (response.ok) {
        const data = await response.json();
        const backendToken = data.token ? data.token : data;
        localStorage.setItem("token", backendToken);
        setIsLoggedIn(true);
        setUserName(decodeJwtName(backendToken));
        setLoginError(null);
      } else {
        if (response.status === 401 || response.status === 403) {
          setLoginError("Login fehlgeschlagen. E-Mail oder Passwort falsch.");
        } else {
          setLoginError(`Error ${response.status}: Login fehlgeschlagen`);
        }
      }
    } catch (error) {
      setLoginError("Ein Fehler ist aufgetreten: " + error.message);
    }
  };

  const googleLoginHandler = async (token) => {
    try {

      const response = await fetch("/auth/google", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + token
        },
        body: JSON.stringify({ token: token }),
      });

      if (response.ok) {
        const data = await response.json();
        const backendToken = data.token ? data.token : data;

        localStorage.setItem("token", backendToken);
        setIsLoggedIn(true);
        setUserName(decodeJwtName(backendToken));
        setLoginError(null);
      } else {
        if (response.status === 403) {
          setLoginError("Error 403: Zugriff verweigert / Login fehlgeschlagen");
        } else {
          setLoginError(`Error ${response.status}: Login fehlgeschlagen`);
        }
        console.error("Google login failed at backend");
      }
    } catch (error) {
      setLoginError("Ein Fehler ist aufgetreten: " + error.message);
      console.error("Error during Google login:", error);
    }
  };
  return (
    <AuthContext.Provider
      value={{
        isLoggedIn: isLoggedIn,
        userName: userName,
        loginError: loginError,
        onLogout: logoutHandler,
        onLogin: loginHandler,
        onGoogleLogin: googleLoginHandler,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
